import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.737 14.235c-.011-.333-.069-1.545-.172-3.635L7.39 13.248c-.261.301-.762.983-1.18.95-.419-.035-.77-.478-.709-.95.308-.742.655-1.252 1.21-2.272.628-1.156 1.683-2.63 2.855-3.37a3.072 3.072 0 0 1 2.586-.314c2.095.717 2.405 3.628 2.423 3.681l.006.003 2.217 1.043a.938.938 0 0 1-.696 1.737l-.538-.179-2.683-1.239-.333 1.24a.935.935 0 0 0 .099.845l3.41 6.927a.937.937 0 0 1-.315 1.333l-.24.135a.937.937 0 0 1-1.255-.309L11.52 18l.07.146-.779 1.15a1.71 1.71 0 0 1-.398.53l-2.866 2.578a.937.937 0 0 1-1.28.167l-.036-.028A.937.937 0 0 1 6 21.268l2.176-2.392c.51-.56.86-1.246 1.018-1.987l.543-2.654zM14.2 4.099a2.1 2.1 0 1 1-4.201 0 2.1 2.1 0 0 1 4.201 0z"
});

var SvgWalkingFilled = function SvgWalkingFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgWalkingFilled;